/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RubrosMSL } from './rubrosMSL';

export interface PagarProductoPagoFacilitoME { 
    secuencialCuentaCliente?: number;
    numeroCuotasPensionesAlimenticiaPersona?: number;
    secuencialResultadoTransaccion?: number;
    jsonComision?: string;
    codigoUsuarioBanca?: string;
    idProducto?: string;
    referencia?: string;
    valorTonelaje?: string;
    identificacion?: string;
    codigoPagarPensionesAlimenticiaEmpresa?: string;
    usuarioId?: string;
    otp?: string;
    comisionRubro?: boolean;
    esBancaWeb?: boolean;
    valor?: number;
    rubros?: Array<RubrosMSL>;
}